import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#64BE49'
            },
            dark: {
                primary: '#64BE49'
            },
        },
    },
});
